import clsx from "clsx"
import { isMobileOnly } from "react-device-detect"
import React from "react"
import { useTranslation } from "react-i18next"

import { useAsideMenu, useTheme } from "hooks"
import ChevronDown from "components/Elements/Icons/ChevronDown"
import { Operator } from "models"

export const OperatorSelector: React.FC = () => {
	const [showDropdown, setShowDropdown] = React.useState(false)

	const { currentTheme, toggleTheme } = useTheme()
	const { operatorsUser } = useAsideMenu()
	const { t } = useTranslation()

	const handleOperatorChange = (operator: Operator) => {
		// Lors du changement d'opérateur, on remet le menu principal par défaut
		setShowDropdown(false)
		toggleTheme(operator)
	}

	return (
		<div
			className={clsx("relative h-[40px] w-auto z-20", {
				"mr-3 mb-2 ": isMobileOnly,
				"mb-6": !isMobileOnly,
			})}
		>
			<div
				data-cy="open-operators"
				onClick={() => setShowDropdown(!showDropdown)}
				onKeyDown={() => setShowDropdown(!showDropdown)}
				className={clsx(
					"h-full flex items-center p-2 rounded-lg justify-between cursor-pointer border-[var(--grey60)] border",
					{
						"border-b-0 rounded-b-none": showDropdown,
						"w-[188px]": isMobileOnly,
						"w-[220px]": !isMobileOnly,
					}
				)}
				role="button"
				tabIndex={0}
			>
				<span className={clsx("font-medium", { "text-s": !isMobileOnly })}>
					{t("menu.operators")}
				</span>
				<ChevronDown size={20} color="white" />
			</div>
			{showDropdown && (
				<div
					className={clsx(
						"bg-[var(--primaryColor)] z-2 rounded-b-lg border-b border-l border-r border-[var(--grey60)]",
						{
							"w-[188px]": isMobileOnly,
							"w-[220px]": !isMobileOnly,
						}
					)}
				>
					{operatorsUser.map((operator, key) => {
						const isCurrentOperator = operator.id_api === currentTheme.id_api

						return (
							<div
								data-cy={`status-${key}-choice`}
								key={`status-${key}`}
								onClick={() => handleOperatorChange(operator)}
								onKeyDown={() => handleOperatorChange(operator)}
								aria-disabled={isCurrentOperator}
								role="button"
								className={clsx("p-2 box-border ", {
									"opacity-50 cursor-not-allowed": isCurrentOperator,
								})}
								tabIndex={key}
							>
								{operator.name}
							</div>
						)
					})}
				</div>
			)}
		</div>
	)
}
